var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.431 7.60337C20.0977 7.98827 20.0977 8.95052 19.431 9.33542L11.2032 14.0857C10.5366 14.4706 9.70325 13.9895 9.70325 13.2197L9.70325 3.71908C9.70325 2.94928 10.5366 2.46816 11.2032 2.85306L19.431 7.60337Z",
    fill: "#FFFCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96655 7.97038C4.96655 6.86581 4.07112 5.97038 2.96655 5.97038C1.86198 5.97038 0.966552 6.86581 0.966552 7.97038L4.96655 7.97038ZM4.96655 21.9427L4.96655 7.97038L0.966552 7.97038L0.966553 21.9427L4.96655 21.9427Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96655 5.97038C1.86198 5.97038 0.966553 6.86581 0.966553 7.97038C0.966553 9.07495 1.86198 9.97038 2.96655 9.97038L2.96655 5.97038ZM2.96655 9.97038L13.9448 9.97038V5.97038L2.96655 5.97038L2.96655 9.97038Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.a2bf2b8e0534223d77b0e6b9b26361d2.svg";
export { ForwardRef as ReactComponent };